import axios from "axios";

//IMPORT API ROUTE URL
import { SEND_RECOMMENDATION } from "./apiRoutes";

const sendRecommendation = (data) => {
  var postData = new FormData();

  postData.append("user_slug", data.user_slug);
  postData.append("resource_slug", data.resource_slug);
  postData.append("subject", data.subject);
  postData.append("content", data.content);
  postData.append("clients", JSON.stringify(data.clients));

  return axios
    .post(SEND_RECOMMENDATION, postData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default sendRecommendation;
